<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <el-form-item label="Son ödəmə tarixi" label-position="top">
            <el-date-picker format="DD.MM.YYYY" v-model="values.payDate" class="w-100" type="date" placeholder="Pick a day" />
        </el-form-item>
        <el-form-item label="Məbləğ" label-position="top">
            <el-input v-model="values.paySum" type="Number" />
        </el-form-item>
        <el-affix position="bottom" :offset="5">
            <div class="row dialog-btn">
                <div>
                    <soft-button @click="SubmitForm()" color="success">
                        {{ !this.editing ? 'Daxil et' : 'Qəbul et' }}</soft-button>
                    &nbsp;&nbsp;&nbsp;
                    <soft-button @click="this.$emit('close-dialog')" color="secondary">Imtina</soft-button>
                </div>
            </div>
        </el-affix>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue"; 
export default {
    components: {
        SoftButton 
    },
    props: {
        editing: Boolean,
        object: Object
    },
    data() {
        return {
            values: {}
        }
    },
    methods: {
        SubmitForm() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                    //None
                }
            })
        }
    },
    mounted() {
        if (this.editing) {
            this.values = { ...this.object }
        } 
    },
}
</script>